import { FloorPlan } from './floorplan';

export class Favorite {
  FloorPlans = new Array<FloorPlan>();
}
